jQuery(document).ready(function() {
    
    // Animate on Scroll init
    AOS.init({
        once: true, // Choose wheter animation should fire once, or every time you scroll up/down to element
        // offset: 200,
        // duration: 600,
        // easing: 'ease-in-sine',
        // delay: 100,
    });

});
